module.exports = __webpack_public_path__ + "static/media/dice-six.216b626b.svg";